import axios from 'axios';
import { authHeader } from '../utils/tokenUtils';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api`;

export const getProducts = (params = {}) => axios.get(`${BASE_URL}/products`, { params });
export const getProduct = (productId) => axios.get(`${BASE_URL}/products/${productId}`);
export const getProductsByCategory = (categoryId) => axios.get(`${BASE_URL}/products/category/${categoryId}`);
export const searchProducts = (keyword) => axios.get(`${BASE_URL}/products/search`, { params: { keyword } });
export const getCategories = () => axios.get(`${BASE_URL}/categories`);
export const createProduct = (formData) => axios.post(`${BASE_URL}/products`, formData, authHeader());
export const updateProduct = (productId, formData) => axios.patch(`${BASE_URL}/products/${productId}`, formData, authHeader());
export const deleteProduct = (productId) => axios.delete(`${BASE_URL}/products/${productId}`, authHeader());